import { render, staticRenderFns } from "./HomeExp.vue?vue&type=template&id=affb5cf0&scoped=true&"
import script from "./HomeExp.vue?vue&type=script&lang=js&"
export * from "./HomeExp.vue?vue&type=script&lang=js&"
import style0 from "./HomeExp.vue?vue&type=style&index=0&id=affb5cf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affb5cf0",
  null
  
)

export default component.exports